import Vue from "vue"

const state = {

}

const mutations = {

}

const actions = {
    async fetchValues({ dispatch }) {
        const { data, status } = await Vue.axios.get("/values");
        // console.log(data)
        if (status != 200) {
            await dispatch("generateSnackBarMessage", { message: 'Ocurrió un error al obtener los rubros', type: 'error' })
        };
        return { data, status };
    },
    async createValue({ dispatch }, value) {
        const formData = new FormData();
        formData.append('file', value.icon);
        formData.append('moral_values', value.moral_values);
        formData.append('description', value.description);
        for (var pair of formData.entries()) {
            // console.log(pair[0]+ ', ' + pair[1]);
        }
        const { data, status } = await Vue.axios.post("/values", formData);
        if (status != 200 && status != 201) {
            await dispatch("createResponseMessage", { message: data.message || 'Ocurrió un error guardando los datos del rubro', type: 'error' })
        } else {
            await dispatch("generateSnackBarMessage", { message: data.message || 'Se guardó correctamente', type: 'success' })
        }
        return { data, status };
    },
    async updateValue({ dispatch }, value) {
        const formData = new FormData();
        formData.append('moral_values', value.moral_values);
        formData.append('description', value.description);
        if (value.file) {
            formData.append('file', value.file)
        }
        const { data, status } = await Vue.axios.post(`/values/${value.id}`, formData);
        if (status != 200 && status != 201 && status != 204) {
            await dispatch("createResponseMessage", { message: data.message || 'Ocurrió un error actualizando los datos del rubro', type: 'error' })
        } else {
            await dispatch("generateSnackBarMessage", { message: data.message || 'Se guardó correctamente', type: 'success' })
        }
        return { data, status };
    },
    async removeValue({ dispatch }, value) {
        const { data, status } = await Vue.axios.delete(`/values/${value.id}`);
        if (status != 200 && status != 204) {
            await dispatch("generateSnackBarMessage", { message: data.message || 'Ocurrió un error eliminando al rubro del sistema', type: 'error' })
        } else {
            await dispatch("generateSnackBarMessage", { message: data.message || 'Rubro eliminado correctamente', type: 'success' })
        }
        return { data, status };
    }
}

export default { state, mutations, actions }

